import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 1.5rem;
  background-color: #f5f7fa;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  max-width: 100%;
  margin-bottom: 2rem;

  h2 {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    color: #333;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
  }

 

  @media (max-width: 768px) {
    padding: 1rem;

    h2 {
      font-size: 1.4rem;
    }

    li {
      font-size: 0.95rem;
      padding: 0.8rem;
    }
  }

  @media (max-width: 480px) {
    ul {
      grid-template-columns: 1fr;
    }

    li {
      padding: 0.75rem;
    }
  }
`;


export const Item = styled.li`
   background-color: ${props => props.selectedStudent ? '#e1e9f0' : '#fff'};
   padding: 1rem;
   border-radius: 0.75rem;
   cursor: pointer;
   transition: all 0.2s ease;
   box-shadow: 0 2px 6px rgba(0,0,0,0.05);
   text-align: center;
   font-weight: 500;
   color: #444;

   &:hover {
   background-color: #e1e9f0;
   transform: scale(1.03);
   }

   
`